import { FC } from 'react';
import { Button } from '@components/atoms/Button';
import { Input } from '@components/atoms/Input';
import { FormGroup } from '@components/molecules/form/FormGroup';
import { useTranslation } from '@hooks/useTranslation';

type ProfileFormProps = {
  values: { firstName: string; lastName: string };
  errors: { firstName?: string; lastName?: string };
  touched: { firstName?: boolean; lastName?: boolean };
  isSubmitting: boolean;
  saving: boolean;
  handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
  email: string;
};

export const ProfileForm: FC<ProfileFormProps> = ({
  email,
  values,
  errors,
  saving,
  touched,
  handleBlur,
  isSubmitting,
  handleSubmit,
  handleChange,
}) => {
  const tSettings = useTranslation('settings');
  const tCommon = useTranslation('common');
  return (
    <form className="mt-10 max-w-xl space-y-6" onSubmit={handleSubmit}>
      <FormGroup label={tCommon.email} htmlFor="email">
        <Input
          disabled
          id="email"
          name="email"
          value={email}
          onBlur={() => {}}
          onChange={() => {}}
          placeholder={tSettings.enterEmailPlaceholder}
        />
      </FormGroup>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormGroup
          label={tSettings.firstName}
          htmlFor="firstName"
          error={touched.firstName ? (errors.firstName as string) : ''}>
          <Input
            id="firstName"
            name="firstName"
            placeholder={tSettings.enterFirstName}
            value={values.firstName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormGroup>
        <FormGroup
          label={tSettings.lastName}
          htmlFor="lastName"
          error={touched.lastName ? (errors.lastName as string) : ''}>
          <Input
            id="lastName"
            name="lastName"
            placeholder={tSettings.enterLastName}
            value={values.lastName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormGroup>
      </div>
      <div className="flex gap-3">
        <Button type="submit" loading={saving || isSubmitting}>
          {tCommon.saveChanges}
        </Button>
      </div>
    </form>
  );
};

export default ProfileForm;
